module.exports = __webpack_public_path__ + "static/media/Taillow_gaussian2.4205d4df.png";